import { forwardRef } from 'react';
import IconBase from '../IconBase';
import { Icon } from '../types';

const Meter2: Icon = forwardRef((props, ref) => (
  <IconBase viewBoxBase={780} ref={ref} {...props}>
    <path d='M390 660c-72.12 0-139.92-28.08-190.92-79.08S120 462.12 120 390s28.08-139.92 79.08-190.92S317.88 120 390 120s139.92 28.08 190.92 79.08S660 317.88 660 390s-28.08 139.92-79.08 190.92S462.12 660 390 660zm0-510c-64.11 0-124.38 24.96-169.71 70.29S150 325.89 150 390s24.96 124.38 70.29 169.71S325.89 630 390 630s124.38-24.96 169.71-70.29S630 454.11 630 390s-24.96-124.38-70.29-169.71S454.11 150 390 150z' />
    <path d='M369.414 389.405l87.333-86.968 21.169 21.257-87.333 86.969z' />
    <path d='M510.17 248.96l-63.64 63.64 21.21 21.21 42.43-42.43c11.72-11.72 11.72-30.71 0-42.43zM269.84 405H180v-30h59.84c16.57 0 30 13.43 30 30zM510 405h89.84v-30H540c-16.57 0-30 13.43-30 30zM405 269.84V180h-30v59.84c0 16.57 13.43 30 30 30z' />
  </IconBase>
));

Meter2.displayName = 'Meter2';

export default Meter2;
